import {Box, Container} from "@mui/material";
import {InfoCard} from "./InfoCard";

export function InfoBox() {
    return (
        <Box>
            <Container maxWidth='lg'>
                <Box sx={{display: 'flex', justifyContent: 'space-around', marginTop: '10px', paddingbottom: '10px', flexWrap: "wrap"}}>
                    <InfoCard header={"Advies"}
                              text={"Ik vertel je graag welke technieken en producten je kan gebruiken om ook thuis je trouwe vriend te kunnen verzorgen!"} />
                    <InfoCard header={"Fullgrooming"}
                              text={"Alles om jouw lieve viervoeter weer tip-top te laten stralen!"} />
                    <InfoCard header={"Puppygewenning"}
                              text={"Een nieuwe pup in huis ? Laat hem kennis maken met het materiaal en natuurlijk de trimster. Dit is gratis tot de leeftijd van 6 maanden!"} />
                </Box>
            </Container>
        </Box>
    )
}